import axios from 'axios'
import { AUTH_LOGOUT } from '@/store/actions/auth'
import {
  clearAuthSession,
  readAuthSession,
  storeAuthSession,
  storeAuthToken
} from '@/utils/authStorage'

let configuredStore = null
let configuredRouter = null
let logoutInProgress = false

const apiClient = axios.create({
  baseURL: process.env.API_URL || 'http://localhost:3000',
  headers: {
    'Content-Type': 'application/json'
  }
})

function authToken () {
  return readAuthSession().token
}

function isAuthEndpoint (url) {
  return url.includes('/auth') || url.includes('/users/login') || url.includes('/login')
}

function acceptResponseToken (token) {
  if (!token || logoutInProgress || !readAuthSession().userId) return

  storeAuthToken(token)
}

function requestLogin () {
  if (logoutInProgress) return

  logoutInProgress = true
  clearAuthSession()

  if (configuredStore) {
    configuredStore.dispatch(AUTH_LOGOUT).catch(() => {})
  }

  if (configuredRouter && configuredRouter.currentRoute.path !== '/login') {
    configuredRouter.replace('/login').catch(() => {})
  }
}

apiClient.interceptors.request.use((config) => {
  const url = config.url || ''
  const token = authToken()

  if (!token && !isAuthEndpoint(url)) {
    requestLogin()
    return Promise.reject(new Error('No authentication token'))
  }

  if (token) {
    config.headers = config.headers || {}
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

apiClient.interceptors.response.use((response) => {
  const url = (response.config && response.config.url) || ''
  const headerToken = response.headers && response.headers['x-auth-token']
  const loginToken = isAuthEndpoint(url) && response.data && response.data.token
  const loginUserId = loginToken && response.data.user && response.data.user.id

  if (loginToken && loginUserId) {
    storeAuthSession({ token: loginToken, userId: loginUserId })
    logoutInProgress = false
  } else {
    acceptResponseToken(headerToken)
  }
  return response
}, (error) => {
  if (error.response && error.response.status === 401) {
    requestLogin()
  }

  return Promise.reject(error)
})

export function configureApiClient ({ baseURL, store, router }) {
  apiClient.defaults.baseURL = baseURL
  configuredStore = store
  configuredRouter = router
}

export default apiClient



// WEBPACK FOOTER //
// ./src/utils/apiClient.js